package com.eladfinish.bible.contest.ui.models

import androidx.compose.ui.text.style.TextAlign

enum class ChapterTextAlign {
    START,
    CENTER,
    END,
    JUSTIFY,
}

fun ChapterTextAlign.toComposeTextAlign(): TextAlign =
    when (this) {
        ChapterTextAlign.START -> TextAlign.Start
        ChapterTextAlign.CENTER -> TextAlign.Center
        ChapterTextAlign.END -> TextAlign.End
        ChapterTextAlign.JUSTIFY -> TextAlign.Justify
    }
